
import {
  Avatar,
  ButtonGroup, Card,
  Column, ConfirmDialog,
  DataTable, DatePicker, Divider,
  IconField,
  InputIcon,
  InputText, Menu, Message, MultiSelect, Panel,
  Select, Tag,
  Textarea, Toast,
  Tooltip
} from "primevue";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Editor from "primevue/editor";

// @note those are the components that are used in the project - this is a workarround as i could not make the import dynamic
// one can have a look at: 'unplugin-vue-components/webpack'; and '@primevue/auto-import-resolver' for a more dynamic approach

const components = {
	Avatar: Avatar,
	Button: Button,
	ButtonGroup: ButtonGroup,
	Card: Card,
	Column: Column,
	ConfirmDialog: ConfirmDialog,
	DataTable: DataTable,
	DatePicker: DatePicker,
	Dialog: Dialog,
	Divider: Divider,
	Editor: Editor,
	IconField: IconField,
	InputIcon: InputIcon,
	InputText: InputText,
	Menu: Menu,
  Message:Message,
  MultiSelect: MultiSelect,
	Panel: Panel,
	Select: Select,
  Tag: Tag,
	Textarea: Textarea,
	Toast: Toast,
	Tooltip: Tooltip,

};

const directives={
	tooltip: Tooltip
}

export default {
	install(app) {
		Object.entries(components).forEach(([componentName, componentInstance]) => {
			app.component(componentName, componentInstance);
		});

		// Direktive registrieren
		Object.entries(directives).forEach(([directiveName, directiveInstance]) => {
			app.directive(directiveName, directiveInstance);
		});
	},
};
